

import { BidiModule } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ɵMwcTransitionPatchModule as MwcTransitionPatchModule } from 'mwc/core/transition-patch';
import { MwcWaveModule } from 'mwc/core/wave';
import { MwcIconModule } from 'mwc/icon';

import { MwcButtonGroupComponent } from './button-group.component';
import { MwcButtonComponent } from './button.component';

@NgModule({
  declarations: [MwcButtonComponent, MwcButtonGroupComponent],
  exports: [MwcButtonComponent, MwcButtonGroupComponent, MwcTransitionPatchModule, MwcWaveModule],
  imports: [BidiModule, CommonModule, MwcWaveModule, MwcIconModule, MwcTransitionPatchModule]
})
export class MwcButtonModule {}
